<div class="container mat-typography">

  <div class="row d-flex justify-content-center">
    <div class="col-2 ">
      <mat-icon style="font-size: 100px" aria-hidden="false" aria-label="Example home icon">lock</mat-icon>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-4">
      <h1 class="mat-display-3">Access Denied</h1>
    </div>
  </div>
  <div class="row d-flex justify-content-center">
    <div class="col-5">
      <h3 class="mat-subheading-2">You do not have access to this site, please contact the site administrator.</h3>
    </div>
  </div>
</div>
